import React from 'react';
import { Calendar } from 'lucide-react';

/**
 * BMW Art Car Tracker header component
 */
const Header = () => {
  return (
    <header className="bg-gradient-to-r from-blue-900 to-black text-white p-4 shadow-md">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="mr-4">
            <svg width="48" height="48" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="50" cy="50" r="45" stroke="white" strokeWidth="2" fill="none" />
              <path d="M50 5 A45 45 0 0 1 95 50 L50 50 Z" fill="#0066B1" />
              <path d="M50 5 A45 45 0 0 0 5 50 L50 50 Z" fill="#0066B1" />
              <path d="M50 95 A45 45 0 0 0 5 50 L50 50 Z" fill="white" />
              <path d="M50 95 A45 45 0 0 1 95 50 L50 50 Z" fill="white" />
            </svg>
          </div>
          <div>
            <h1 className="text-2xl font-light tracking-wider">BMW ART CAR COLLECTION</h1>
            <p className="text-sm font-light">50TH ANNIVERSARY WORLD TOUR 2025</p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <Calendar size={20} className="mr-1" />
          <span className="text-sm font-light">TIMELINE & MAP VIEW</span>
        </div>
      </div>
    </header>
  );
};

export default Header;